import React, { useState } from 'react';
import Backgroundimage from '../../assets/images/background/image-7.jpg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import quotesone from '../../assets/images/icons/quotes-1.png';


function Testimonialsabout() {
  const [prevEl, setPrevEl] = useState(null);
  const [nextEl, setNextEl] = useState(null);

  const show = {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    modules: [Navigation, Autoplay],
    navigation: {
      prevEl,
      nextEl,
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  };

  return (
    <section className="testimonials-two">
      <div className="image-layer" style={{ backgroundImage: `url(${Backgroundimage})` }}></div>
      <div className="auto-container">
        <div className="title-box centered">
          <div className="subtitle">
            <span>Šta kažu naši gosti</span>
          </div>
          <div className="pattern-image">
            <img src={require('../../assets/images/icons/separator.svg').default} alt="mySvgImage" />
          </div>
          <h2>Utisci gostiju</h2>
        </div>

        <div className="carousel-box">
          <Swiper className="testimonial-slider" {...show}>
            <SwiperSlide className="testi-block item">
              <div className="inner-box">
                <div className="quote-icon">
                  <img src={quotesone} alt="" title="" />
                </div>
                <div className="rating">
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                </div>
                <div className="text">
                  Pizza je neverovatna, najbolja u Smederevu! Tortilje su takođe odlične, a dostava je uvek brza. Bon Appetit je naš prvi izbor za porodične večere!
                </div>
                <div className="auth-info" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingLeft: 0 }}>
                  {/* <div className="image">
                    <img src={authorthumb} alt="" />
                  </div> */}
                  <div className="auth-title">Ana Petrović</div>
                  <div className="location">Smederevo</div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide className="testi-block item">
              <div className="inner-box">
                {/* <div className="quote-icon">
                  <img src={quotesone} alt="" title="" />
                </div> */}
                <div className="rating">
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                </div>
                <div className="text">
                  Pored odlične hrane, ovde se osećaš kao kod kuće. Sve je čisto i uredno, osoblje je ljubazno, a ambijent je prijatan. Vraćam se uvek sa zadovoljstvom!
                </div>
                <div className="auth-info" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingLeft: 0 }}>
                  {/* <div className="image">
                    <img src={authorthumbone} alt="" />
                  </div> */}
                  <div className="auth-title">Stefan Nikolić</div>
                  <div className="location">Smederevo</div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide className="testi-block item">
              <div className="inner-box">
                <div className="quote-icon">
                  <img src={quotesone} alt="" title="" />
                </div>
                <div className="rating">
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                  <span className="fa fa-star"></span>
                </div>
                <div className="text">
                  Poseban doživljaj! Hrana je bila toliko ukusna da se i dalje sećam tog obroka. Savršeno pripremljeno, toplo preporučujem svima koji vole kvalitetnu hranu!
                </div>
                <div className="auth-info" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingLeft: 0 }}>
                  {/* <div className="image">
                    <img src={authorthumbtwo} alt="" />
                  </div> */}
                  <div className="auth-title">Marko Jovanović</div>
                  <div className="location">Beograd</div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="swiper-button-prev-c" ref={(node) => setPrevEl(node)}>
            <span className="fal fa-angle-left"></span>
          </div>
          <div className="swiper-button-next-c" ref={(node) => setNextEl(node)}>
            <span className="fal fa-angle-right"></span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonialsabout;